import { getApiClient } from '@aslanpay/portal-common-lib';

import {
  CreateDeductionAdjustmentRequest,
  DeductionAdjustment,
  DeductionAdjustmentsPage,
  FetchDeductionAdjustmentsRequest,
} from 'app/types/deductionAdjustments';

const ADJUSTMENTS_PATH = '/reports-service/deductions/adjustments';

const DeductionAdjustmentsApiHandler = {
  createAdjustment: async (request: CreateDeductionAdjustmentRequest) => {
    const { data } = await getApiClient().post<DeductionAdjustment>(ADJUSTMENTS_PATH, request);
    return data;
  },

  listAdjustments: async ({
    individualIds,
    individualReportIds,
    page,
    size,
  }: FetchDeductionAdjustmentsRequest) => {
    const { data } = await getApiClient().get<DeductionAdjustmentsPage>(ADJUSTMENTS_PATH, {
      params: { individualIds, individualReportIds, page, size },
      paramsSerializer: { indexes: null },
    });
    return data;
  },
};

export default DeductionAdjustmentsApiHandler;
